import { render, staticRenderFns } from "./Logof.vue?vue&type=template&id=32def087&scoped=true&"
import script from "./Logof.vue?vue&type=script&lang=js&"
export * from "./Logof.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32def087",
  null
  
)

export default component.exports